import LCOLOGO from "/media/Images/LCO_LOGO.jpg"
const APPCONFIG = {
  title: "elevate",
  logo: LCOLOGO,
  url: "/"
};
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

export default APPCONFIG;